import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { OrdersService } from '../../../shared/services/orders.service';
import { FieldOfOrderAggregate, OrderAggregate } from '../../models/aggregation/order-aggregate';
import { NumberPipe } from '../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-order-situation',
	templateUrl: './order-situation.component.html',
	styleUrl: './order-situation.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	animations: pageTransitions,
	imports: [
		TranslateModule,
		NgIf,
		MatRippleModule,
		MatIconModule,
		LoadingSpinnerComponent,

		MatButtonModule,
		NumberPipe
	]
})
export class OrderSituationComponent implements OnDestroy {
	orderQuantities?: OrderAggregate;
	isLoading = true;
	private readonly fields: readonly FieldOfOrderAggregate[] = [
		'grossQtyInProduction',
		'grossQtyAvailableReadyToShip',
		'grossQtyAvailableInTransit',
		'grossQtyDelivered'
	];

	private readonly orderAggregateSub: Subscription;

	constructor(
		private readonly ordersService: OrdersService,
		private readonly router: Router
	) {
		this.orderAggregateSub = this.ordersService.getOrderAggregateQuantity(this.fields).subscribe({
			next: value => {
				this.orderQuantities = value[0];
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('error loading order situation', err);
				this.isLoading = false;
			}
		});
	}

	async viewDetails(filter?: string) {
		await this.router.navigateByUrl('/order-tracking/order/datacenter', filter ? {
			state: {
				filter: [
					{
						id: 'ordersWithMaterial',
						values: [
							[
								{
									apiName: 'grossQtyInProduction',
									selected: filter === 'grossQtyInProduction'
								},
								{
									apiName: 'grossQtyAvailableReadyToShip',
									selected: filter === 'grossQtyAvailableReadyToShip'
								},
								{
									apiName: 'grossQtyAvailableInTransit',
									selected: filter === 'grossQtyAvailableInTransit'
								},
								{
									apiName: 'grossQtyAvailableInConsignment',
									selected: false
								},
								{
									apiName: 'grossQtyDelivered',
									selected: filter === 'grossQtyDelivered'
								}
							]
						]
					}
				]
			}
		} : undefined);
	}

	ngOnDestroy() {
		this.orderAggregateSub.unsubscribe();
	}
}
